import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const professionDirectionService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession-direction/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching profession list", error);
            throw error;
        }
    },

    async findByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/profession-direction/findByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByUuid profession-direction", error);
            throw error;
        }
    },

    async save(profession: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession-direction/save`,
                profession
            );
            return response.data;
        } catch (error) {
            console.error("Error save profession-direction", error);
            throw error;
        }
    },

    async deleteByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/profession-direction/deleteByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByUuid profession-direction", error);
            throw error;
        }
    },

    async getAllDirectionList(): Promise<any[]> {
        try {
            const response = await apiClient.get<any[]>(`${BASE_URL}/api/v1/profession-direction/all-list`);
            return response.data;
        } catch (error) {
            console.error("Error getAllProfessionDirections", error);
            throw error;
        }
    },
}

export default professionDirectionService;
